<template>
  <span v-if="invalid" class="lips validation">* {{errorMessage}}</span>
</template>
<script>
  export default {
    props: {
      required: {
        type: Boolean,
        default: false
      },
      invalid: {
        type: Boolean,
        default: false
      },
      errorMessage: {
        type: String,
        default: ''
      }
    }
  }
</script>
